// feature profile
export { getGeneralDetailsSettings } from './general-details';
